module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.counter) ? _c('div', {
    staticClass: "card",
    class: 'card-' + _vm.size
  }, [(_vm.$slots.headline) ? _c('header', [_vm._t("headline")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_vm._t("content")], 2), _vm._v(" "), _c('aside', {
    staticClass: "card-sidebar"
  }, [(_vm.counter !== null) ? _c('span', {
    staticClass: "card-counter"
  }, [_vm._v(_vm._s(_vm.counter))]) : _vm._e(), _vm._v(" "), _vm._t("sidebar")], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bab92a7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/dashboard/Card.vue
// module id = 618
// module chunks = 234